<template lang="pug">
  #main
    .container
      .row
        .col
          h1.display-4.py-2 Scanner
      .row
        .col 
          b-button(@click="logout").btn Logout
          b-button(@click="getApiToken").btn AToken
          b-button(@click="checkout('individual')").btn Checkout Ind
          //- b-button(@click="testauch").btn Check Auth
          //- b-button(@click="testauch2").btn Check 2
      .row
        .col(v-if="showToken")
          h4(v-bind:data="infoText") {{ infoText }}
          .alert.alert-info
            span(v-bind:data="apiToken") {{ apiToken }}
      .row
        .col 
          //- b-button(@click="deleteUser" v-bind:variant="deleteButtonType") Benutzer löschen
          .px-2(v-if="deleteErr", style="color: red", v-bind:data="errorText") {{ errorText }}
      .row
        .col
          image-uploader(@input="setImage" accept=".jpg, .png" :capture="false" :debug="1", outputFormat="string", :className="['fileinput']", :maxWidth="1600", :maxHeight="1600", :quality="0.7")
          b-button(v-if="scanButtonState" variant="primary" @click="scanImage") Scannen
      .row
        b-table(:items="returnedBCData", v-if="showEmptyResponse")
        span(v-bind:data="noBCText", v-if="!showEmptyResponse") {{ noBCText }}
        
          
          

</template>

<script>
import { auth } from "firebase";
import axios from "axios";
import ImageUploader from "vue-image-upload-resize";
import {env_config} from '../config/firebase'

export default {
  name: "Scanner",
  components: {
    ImageUploader
  },
  data() {
    return {
      deleteButtonType: "info",
      deleteButtonCounter: 0,
      errorText: "",
      deleteErr: false,
      infoText: "Token: ",
      apiToken: "",
      showToken: false,
      image: "",
      scanButtonState: false,
      returnedBCData: [],
      showEmptyResponse: true,
      noBCText: ""
    };
  },
  methods: {
    logout: function() {
      auth()
        .signOut()
        .then(() => {
          this.$router.push("/");
        });
    },
    setImage: function(img) {
      this.image = img;
      this.scanButtonState = true;
    },
    scanImage: function() {
      auth()
        .currentUser.getIdToken(/* forceRefresh */ true)
        .then(idToken => {
          axios
            .post(
              env_config.url_api_root + 'v1/image',
              {
                image: this.image
              },
              {
                headers: { Authorization: `Bearer ${idToken}` }
              }
            )
            .then(response => {
              if (response.data.err) {
                this.showEmptyResponse = false
                this.noBCText = response.data.message
              } else {
                
                if (response.data.length > 0) {
                  this.showEmptyResponse = true
                  this.returnedBCData = response.data
                } else {
                  this.showEmptyResponse = false
                  this.noBCText = "Es wurden keine Werte erkannt"
                }
              }
            })
            .catch(e => {
              console.log(e);
              this.errors.push(e);
            });
        });
    },
    checkout: function(type) {
      auth()
        .currentUser.getIdToken(true)
        .then(idToken => {
          axios
            .post(
              env_config.url_api_root + "v1/createpayment",
              {
                token: idToken,
                type: type
              },
              {
                headers: { Authorization: `Bearer ${idToken}` }
              }
            )
            .then(res => {
              location.replace(res.data.checkoutURI);
            })
            .catch(e => {
              console.log(e);
            });
        });
    },
    getApiToken: function() {
      auth()
        .currentUser.getIdToken(/* forceRefresh */ true)
        .then(idToken => {
          axios
            .post(
              env_config.url_api_root + "v1/token",
              {
                token: idToken
              },
              {
                headers: { Authorization: `Bearer ${idToken}` }
              }
            )
            .then(response => {
              this.apiToken = response.data;
              this.showToken = true;
            })
            .catch(e => {
              console.log(e);
            });
        });
    },
    deleteUser: function() {
      var self = this;
      if (this.deleteButtonCounter == 1) {
        var user = auth().currentUser;
        user
          .delete()
          .then(function() {
            self.$router.push("/");
          })
          .catch(function(error) {
            this.errorText = error;
            this.deleteErr = true;
          });
      }
      if (this.deleteButtonCounter == 0) {
        this.deleteButtonCounter++;
        this.deleteButtonType = "danger";
      }
    }
  }
};
</script>

<style>
.fileinput,
.img-preview {
  border: 1px solid red;
  display: block;
  height: auto;
  width: auto;
  max-width: 500px;
  max-height: 500px;
}
</style>